module.exports = __webpack_public_path__ + "img/1F3F4-E0067-E0062-E0073-E0063-E0074-E007F.491d545c.svg";